import {Component, Input, OnChanges, SimpleChanges, ViewChild} from "@angular/core";
import {
  ChartComponent,
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart, NgApexchartsModule, ApexTooltip, ApexDataLabels
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexNonAxisChartSeries | { name: string; data: number[] }[];
  chart: ApexChart;
  labels: string[];
  dataLabels: ApexDataLabels;
  responsive: ApexResponsive[];
  tooltip: ApexTooltip
};


@Component({
  selector: 'user-stats',
  standalone: true,
  imports: [
    NgApexchartsModule
  ],
  templateUrl: './user-stats.component.html',
  styleUrl: './user-stats.component.scss'
})
export class UserStatsComponent implements OnChanges{

  @ViewChild("chart") chart!: ChartComponent;

  @Input() users: any[] = [];
  @Input() type: 'active' | 'created' | 'created-by-month' = 'active';
  @Input() title: string = '';

  public chartOptions: ChartOptions;
  constructor() {
    this.chartOptions = {
      series: [0, 0],
      chart: {
        type: "pie"
      },
      labels: ["Active", "Inactive"],
      dataLabels: {
        enabled: true,
        formatter: function (val: any, opts: any) {
          return String(opts.w.config.series[opts.seriesIndex]);
        }
      },
      tooltip: {
        y: {
          formatter: function (value: any) {
            return String(value);
          }
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { width: 300 },
            legend: { position: "bottom" }
          }
        }
      ]
    };
  }

  ngOnChanges(_: SimpleChanges): void {
    if (!this.users?.length) return;
    this.updateChart();
  }

  updateChart() {
    if (this.type === 'active') {
      this.buildActiveChart();
    } else if (this.type === 'created') {
      this.buildCreatedByChart();
    } else if (this.type === 'created-by-month') {
      this.buildCreatedByMonthChart();
    }
  }

  private buildActiveChart() {
    const active = this.users.filter(user => user.is_active).length;
    const inactive = this.users.filter(user => !user.is_active).length;

    this.chartOptions = {
      ...this.chartOptions,
      series: [active, inactive],
      labels: ['Active', 'Inactive']
    };
  }

  private buildCreatedByChart() {
    const counts: Record<string, number> = {};

    this.users.forEach(user => {
      counts[user.created_by] = (counts[user.created_by] || 0) + 1;
    });

    this.chartOptions = {
      ...this.chartOptions,
      series: Object.values(counts),
      labels: Object.keys(counts)
    };
  }

  private buildCreatedByMonthChart() {
    const counts: Record<string, { count: number; date: Date }> = {};

    this.users.forEach(u => {
      if (!u.created_at) return;

      const date = new Date(u.created_at);

      const label = date.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric'
      });

      if (!counts[label]) {
        counts[label] = {
          count: 0,
          date: new Date(date.getFullYear(), date.getMonth(), 1)
        };
      }

      counts[label].count += 1;
    });

    const sortedEntries = Object.entries(counts).sort((a, b) => {
      return a[1].date.getTime() - b[1].date.getTime();
    });

    const labels = sortedEntries.map(e => e[0]);
    const series = sortedEntries.map(e => e[1].count);

    this.chartOptions = {
      ...this.chartOptions,
      chart: {
        ...this.chartOptions.chart,
        type: "bar"
      },
      series: [
        {
          name: "users",
          data: series
        }
      ],
      labels,
      dataLabels: {
        enabled: true,
        formatter: (val: any) => val
      },
      tooltip: {
        y: {
          formatter: (value: any) => `${value}`
        }
      }
    };
  }



}
